<template>
    <div class="more-navigation" :class="{'more-navigation--open': isOpen }">
        <a ref="toggle" @click.prevent="toggle" href="#">
            <icon :type="icon" color="bluegray" size="16" />
        </a>
        <portal ref="portal" to="dialog">
            <menu-items @close="close" :top="position.y" :left="position.x" v-if="isOpen">
                <slot :close="close" />
            </menu-items>
        </portal>
    </div>
</template>

<script>
import Toggleable from '../../mixins/toggle'
import MenuItems from './MenuItems'
import Icon from './Icon'

export default {
    mixins: [Toggleable],

    data () {
        return {
            position: null
        }
    },

    props: {
        orientation: {
            required: false,
            default: 'vertical',
            validator (value) {
                return ['vertical', 'horizontal'].includes(value)
            }
        }
    },

    methods: {
        beforeToggle (event) {
            this.position = event.target.getBoundingClientRect()
        }
    },

    computed: {
        icon () {
            const lang = {
                'vertical': 'more-vertical',
                'horizontal': 'more-horizontal'
            }

            return lang[this.orientation]
        }
    },

    components: {
        Icon,
        MenuItems
    }
}
</script>

<style scoped lang="less">
    .more-navigation {
        position: relative;

        &--open {
            icon {
                opacity: 1;
            }
        }
    }
</style>
